









































































































import Vue, { PropType } from "vue";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { getToday, isDiffOfTwoDateOverTargetMonth } from "@/commons/utils/dateHandling";
import { Enum } from "@/commons/enums/Type";
import { CwvDeviceTypeEnum } from "@/features/coreWebVitals/enums/CwvDeviceType";

// レポートで選択できる期間(month)
const AVAILABILITY_PERIOD = 1;

extend("exceeding_availability_period", {
  params: [
    {
      name: "target",
      isTarget: true,
    },
  ],
  message: `選択期間を${AVAILABILITY_PERIOD}ヶ月以内にしてください`,
  validate(value, { target }: any) {
    return !isDiffOfTwoDateOverTargetMonth(value, target, AVAILABILITY_PERIOD);
  },
});

export default Vue.extend({
  components: {
    "validation-observer": ValidationObserver,
    "validation-provider": ValidationProvider,
  },

  props: {
    loading: { type: Boolean, required: true },
    startDate: { type: String, required: true },
    endDate: { type: String, required: true },
    isNotReportExecution: { type: Boolean },
    clickEvent: { type: Function as PropType<() => void>, required: true },
    deviceTypeInput: { type: Number },
  },

  data() {
    return {
      today: getToday(),
      startDateMenu: false,
      endDateMenu: false,
      minStartDate: "2022-06-01",
    };
  },

  computed: {
    childStartDate: {
      get() {
        return (this as any).startDate;
      },
      set(val) {
        return this.$emit("update:startDate", val);
      },
    },
    childEndDate: {
      get() {
        return (this as any).endDate;
      },
      set(val) {
        return this.$emit("update:endDate", val);
      },
    },
    childDeviceTypeInput: {
      get() {
        return (this as any).deviceTypeInput;
      },
      set(val) {
        return this.$emit("update:deviceTypeInput", val);
      },
    },
    deviceTypeItems(): Enum[] {
      return [
        { value: CwvDeviceTypeEnum.DESKTOP.value, text: CwvDeviceTypeEnum.DESKTOP.text },
        { value: CwvDeviceTypeEnum.MOBILE.value, text: CwvDeviceTypeEnum.MOBILE.text },
      ];
    },
  },

  watch: {
    childStartDate: function () {
      // 「開始日」を変更し開始日が終了日を超えた場合、終了日を開始日と同じ日付に変更
      if (this.childStartDate > this.childEndDate) this.childEndDate = this.childStartDate;
    },
    childEndDate: function () {
      // 「終了日」を変更し開始日が終了日を超えた場合、開始日を終了日と同じ日付に変更
      if (this.childStartDate > this.childEndDate) this.childStartDate = this.childEndDate;
    },
  },
});
